import { render, staticRenderFns } from "./SidebarProvider.vue?vue&type=template&id=2a69116a"
import script from "./SidebarProvider.vue?vue&type=script&lang=ts"
export * from "./SidebarProvider.vue?vue&type=script&lang=ts"
import style0 from "./sidebar.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports